import { type FC } from "react";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import { Loading } from "../../../Loading";
import { useScoutUserCassettes } from "../../../ScoutUserCassettes/useScoutUserCassettes";
import { UserCassette } from "../../../UserCassette";
import * as styles from "./styles.css";

type SpUserCassetteProps = {
  fetchUrl: string;
  fetchParams: Record<string, unknown>;
  selectedUsers: number[];
  isBundled: boolean;
  onSelectedUserChange: (values: number[]) => void;
};

export const SpUserCassette: FC<SpUserCassetteProps> = ({
  fetchUrl,
  fetchParams,
  selectedUsers,
  isBundled,
  onSelectedUserChange,
}) => {
  const userInformationList = useScoutUserCassettes(fetchUrl, fetchParams);

  const handleSelectCheckboxChange = (value: string) => {
    const numericValue = Number(value);
    onSelectedUserChange(
      selectedUsers.includes(numericValue)
        ? selectedUsers.filter((id) => id !== numericValue)
        : [...selectedUsers, numericValue],
    );
  };

  // APIリクエストがまだ完了していない場合はローディングを表示
  if (!userInformationList) {
    return <Loading isShadow={isBundled} />;
  }

  // 本来0件になることはないので、その場合はnewRelicにエラー通知する
  if (userInformationList.length === 0) {
    sendErrorLog(new Error("求職者の情報を取得できませんでした"));
  }

  return (
    <>
      {userInformationList.map((userInformation) => {
        const userId = userInformation.multiScoutInfo?.userId;
        const isChecked = (userId && selectedUsers.includes(Number(userId))) || false;
        return (
          <div key={userInformation.userDetailFetchUrl} className={styles.outer}>
            <UserCassette
              userInformation={userInformation}
              userStatus={
                userInformation.multiScoutInfo
                  ? { ...userInformation.multiScoutInfo, isChecked }
                  : undefined
              }
              isShowCheckbox={isBundled}
              handleChangeCheckbox={handleSelectCheckboxChange}
              isShowScoutNavigation={false}
            />
          </div>
        );
      })}
    </>
  );
};
